






















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import ErrorDialog from "./ErrorDialog.vue";
import ChangeLogEntryDialog from "./ChangeLogEntryDialog.vue";
import RowActions from "./RowActions.vue";
import { EnumHelpers, LogType } from "../helpers/EnumHelpers";
import { ErrorHandlingHelpers } from "../helpers/ErrorHandlingHelpers";
import { FailureResponseData } from "../models/FailureResponseData";
import { ChangeLogEntryData } from "../models/ChangeLogEntryData";

@Component({
  components: { RowActions, ErrorDialog, ChangeLogEntryDialog },
})
export default class ChangesLogTable extends Vue {
  @Prop({ required: false })
  public changeLogEntries!: ChangeLogEntryData[];
  @Prop({ default: true })
  public loading: boolean;

  public selectedToolVersions: Array<object> = [];
  private entryDialogIsShown: boolean = false;
  private entryDialogIsEditing: boolean = false;
  private entryToEdit: ChangeLogEntryData = new ChangeLogEntryData(
    LogType.Other,
    ""
  );
  private headers = [
    { text: "Type", value: "type", width: "15%" },
    { text: "Name", value: "name", width: "25%" },
    { text: "Description", value: "description", width: "50%" },
    { text: "Actions", value: "actions", width: "10%" },
  ];
  @Watch("changeLogEntries")
  public onPropertyChanged(
    value: ChangeLogEntryData[],
    oldvalue: ChangeLogEntryData[]
  ) {}
  @Watch("changeLogEntries")
  public onLoadingPropertyChanged(value: boolean, oldvalue: boolean) {}

  public toolVersions;
  private getType(type: number) {
    return EnumHelpers.GetLogTypeName(type);
  }

  private getColor(type: number) {
    return EnumHelpers.GetColor(EnumHelpers.GetLogTypeValue(type));
  }

  private initiateEditLogEntry(item) {
    const itemtoEdit = new ChangeLogEntryData(
      EnumHelpers.GetLogTypeValue(item.type),
      item.description,
      "",
      item.name
    );
    this.entryToEdit = itemtoEdit;
    this.entryDialogIsEditing = true;
    this.entryDialogIsShown = true;
  }
  private editLogEntry(oldEntry, newEntry) {
    this.$emit("entryEdited", oldEntry, newEntry);
  }
  private deleteLogEntry(item) {
    const itemtoDelete = new ChangeLogEntryData(
      EnumHelpers.GetLogTypeValue(item.type),
      item.description,
      "",
      item.name
    );
    this.$emit("entryRemoved", itemtoDelete);
  }
  private initiateAddLogEntry() {
    this.entryDialogIsEditing = false;
    this.entryDialogIsShown = true;
  }
  private addLogEntry(item) {
    this.$emit("entryAdded", item);
  }

  private async created() {}
}
